// src/components/HeroSection.jsx
import React, { useState } from "react";
import "../assets/css/Hero.css";
import heroImg from "../assets/imgs/hero-image2.png";  // Add your hero PNG

import OrchestratedUI from "./OrchestratedUI";

const HeroSection = () => {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        state: "",
        city: "",
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        alert("Request submitted!");
    };

    return (
        <>
            <section className="am-hero" id="home">
                {/* LEFT SIDE */}
                <div className="am-hero-left">
                    <div className="badge">Monitor • Evaluate • Improve</div>

                    <h1>
                        Solving the Academic Struggles  of  <span>Students & Parents</span>
                        
                       
                    </h1>

                    <p className="subtext">
                        <strong className="marathi-text">विद्यार्थ्यांच्या आणि पालकांच्या शैक्षणिक अडचणी सोडविण्यासाठी</strong>
                        <br />
                        Aabhyas Mitra is a structured academic system for students of
                        8th, 9th & 10th (SSC, CBSE, ICSE) that removes confusion,
                        builds discipline, and delivers results.
                    </p>

                    <ul className="hero-points">
                        <li className="marathi-text">🧠 आपल्या मुला/मुलीच्या परीक्षेची अजिबात चिंता करण्याची गरज नाही</li>
                        <li>📊 Continuous Monitoring & Performance Tracking</li>
                        <li>📘 Daily Study Routine & Guided Practice</li>
                        <li>🤝 Parent–Student–Mentor Transparency</li>
                    </ul>
                </div>

                {/* RIGHT SIDE FORM */}
                <div className="am-hero-form-card">
                    {/* <h2>Request a Call Back</h2> */}

                    <img
                        src={heroImg}
                        alt="Student guided by mentor"
                        className="am-hero-visual"
                    />



                    {/* <form onSubmit={handleSubmit}>
                        <input
                            type="text"
                            name="name"
                            placeholder="Full Name"
                            required
                            onChange={handleChange}
                        />

                        <div className="phone-row">
                            <span className="country-code">+91</span>
                            <input
                                type="tel"
                                name="phone"
                                placeholder="Mobile Number"
                                required
                                onChange={handleChange}
                            />
                            <button className="verify-btn" type="button">
                                Verify
                            </button>
                        </div>

                        <input
                            type="email"
                            name="email"
                            placeholder="Email"
                            required
                            onChange={handleChange}
                        />

                        <div className="two-input-row">
                            <input
                                type="text"
                                name="state"
                                placeholder="State"
                                required
                                onChange={handleChange}
                            />
                            <input
                                type="text"
                                name="city"
                                placeholder="City"
                                required
                                onChange={handleChange}
                            />
                        </div>

                        <label className="check-row">
                            <input type="checkbox" required />
                            I agree to receive updates & communication.
                        </label>

                        <button className="eligibility-btn" type="button">
                        ✔ Check Eligibility Criteria
                    </button>

                        <p className="fee-text">Application Fee ₹000/- (Non-refundable)</p>

                        <button className="pay-btn" type="submit">
                             Submit
                        </button>
                    </form> */}
                </div>

            </section>

            <section className="stats-section">
                <div className="stats-container">

                    <div className="stats-left">
                        <p>
                            We speak with <br />
                            our powerful results
                        </p>
                    </div>

                    <div className="stats-item">
                        <h2>50,000+</h2>
                        <span>Students Guided</span>
                    </div>

                    <div className="stats-item">
                        <h2>10,000+</h2>
                        <span>Daily Practice Sessions</span>
                    </div>

                    <div className="stats-item">
                        <h2>1.2 Cr+</h2>
                        <span>MCQs Attempted</span>
                    </div>

                </div>
            </section>


         {/* <ProblemsWeSolve /> */}

         <OrchestratedUI />



        </>
    );
};

export default HeroSection;
